export class AvailableQueryParameters {
  actioned?: string;
  availableDateFrom?: string;
  availableDateTo?: string;
  equityThreshold?: number;
  inEquity?: string | string[];
  monthsOutFrom?: number;
  monthsOutTo?: number;
  originalSalespersonId?: string;
  page?: number;
  pageSize?: number;
  rooftopId?: string;
  salespersonId?: string[];
  saleStatusId?: string[];
  saleTypeId?: string[];
  sort?: string;
  termFrom?: number;
  termTo?: number;
  userEmployeeId?: string;
  vehicleId?: string;

  constructor(obj?: AvailableQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
